import { render } from "./SequencesList.vue?vue&type=template&id=253fdf78&scoped=true"
import script from "./SequencesList.vue?vue&type=script&lang=js"
export * from "./SequencesList.vue?vue&type=script&lang=js"

import "./SequencesList.vue?vue&type=style&index=0&id=253fdf78&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253fdf78"]])

export default __exports__